export const CANADA = 'country_Canada';
export const QATAR = 'country_Qatar';
export const UAE = 'country_United_Arab_Emirates';
export const USA = 'country_United_States';
export const COUNTRY_TITLE = 'country_title';
